import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'hr-template-display',
  templateUrl: './template-display.component.html',
  styleUrls: ['./template-display.component.less'],
  standalone: false,
})
export class TemplateDisplayComponent implements OnInit {
  private _templateTitle: string;
  private _templateContent: string;
  public isDisabled: boolean;

  @Input() set templateContent(templateContent: string) {
    if (templateContent) this._templateContent = templateContent;
  }
  get templateContent(): string {
    return this._templateContent;
  }

  @Input() set templateTitle(templateTitle: string) {
    if (templateTitle) this._templateTitle = templateTitle;
  }
  get templateTitle(): string {
    return this._templateTitle;
  }

  constructor() {
    this.isDisabled = true;
  }

  ngOnInit() {}
}
